import {
  EPaymentOrderType,
  EPaymentRepetitionType,
} from "@rentiohq/shared-frontend/dist/types/payment.types";
import { EPropertyMemberTypes } from "@rentiohq/shared-frontend/dist/types/property.types";
import { TAssetSource } from "@rentiohq/web-shared/dist/components";

interface IPaymentOrderType {
  ids: EPaymentOrderType[];
  repetitionType: EPaymentRepetitionType;
  repetitionDay: number;
  allowedPayerRoles: EPropertyMemberTypes[];
  defaultPayerRole?: EPropertyMemberTypes;
  defaultPayeeRole?: EPropertyMemberTypes;
  allowedPayeeRole: EPropertyMemberTypes[];
  icon: TAssetSource;
}

export const getPaymentOrderTypeById = (id: EPaymentOrderType) => {
  return paymentOrderTypes.find(type => type.ids.includes(id));
};

const paymentOrderTypes: IPaymentOrderType[] = [
  {
    ids: [EPaymentOrderType.Rent],
    repetitionType: EPaymentRepetitionType.Monthly,
    repetitionDay: 1,
    allowedPayerRoles: [
      EPropertyMemberTypes.Tenant,
      EPropertyMemberTypes.Parent,
    ],
    defaultPayerRole: EPropertyMemberTypes.Tenant,
    allowedPayeeRole: [EPropertyMemberTypes.Owner],
    defaultPayeeRole: EPropertyMemberTypes.Owner,
    icon: "forRentSign",
  },
  {
    ids: [EPaymentOrderType.CommonCosts],
    repetitionType: EPaymentRepetitionType.Monthly,
    repetitionDay: 1,
    allowedPayerRoles: [
      EPropertyMemberTypes.Tenant,
      EPropertyMemberTypes.Parent,
    ],
    defaultPayerRole: EPropertyMemberTypes.Tenant,
    allowedPayeeRole: [EPropertyMemberTypes.Owner],
    defaultPayeeRole: EPropertyMemberTypes.Owner,
    icon: "houseWrench",
  },
  {
    ids: [EPaymentOrderType.NonCommonCosts],
    repetitionType: EPaymentRepetitionType.Monthly,
    repetitionDay: 1,
    allowedPayerRoles: [
      EPropertyMemberTypes.Tenant,
      EPropertyMemberTypes.Parent,
    ],
    defaultPayerRole: EPropertyMemberTypes.Tenant,
    allowedPayeeRole: [EPropertyMemberTypes.Owner],
    defaultPayeeRole: EPropertyMemberTypes.Owner,
    icon: "billSplit",
  },
  {
    ids: [EPaymentOrderType.ManagementCosts],
    repetitionType: EPaymentRepetitionType.Monthly,
    repetitionDay: 1,
    allowedPayerRoles: [EPropertyMemberTypes.Owner],
    defaultPayerRole: EPropertyMemberTypes.Owner,
    allowedPayeeRole: [EPropertyMemberTypes.Broker],
    defaultPayeeRole: EPropertyMemberTypes.Broker,
    icon: "keys",
  },
  {
    ids: [EPaymentOrderType.Rentio],
    repetitionType: EPaymentRepetitionType.Monthly,
    repetitionDay: 1,
    allowedPayerRoles: [
      EPropertyMemberTypes.Tenant,
      EPropertyMemberTypes.Parent,
      EPropertyMemberTypes.Owner,
    ],
    defaultPayerRole: EPropertyMemberTypes.Tenant,
    allowedPayeeRole: [EPropertyMemberTypes.Broker],
    defaultPayeeRole: EPropertyMemberTypes.Broker,
    icon: "smartphone",
  },
  {
    ids: [EPaymentOrderType.RentDeposit],
    repetitionType: EPaymentRepetitionType.Once,
    repetitionDay: 1,
    allowedPayerRoles: [
      EPropertyMemberTypes.Tenant,
      EPropertyMemberTypes.Parent,
    ],
    defaultPayerRole: EPropertyMemberTypes.Tenant,
    allowedPayeeRole: [EPropertyMemberTypes.Broker, EPropertyMemberTypes.Owner],
    icon: "safe",
  },
  {
    ids: [EPaymentOrderType.LocationDescription],
    repetitionType: EPaymentRepetitionType.Once,
    repetitionDay: 1,
    allowedPayerRoles: [
      EPropertyMemberTypes.Tenant,
      EPropertyMemberTypes.Parent,
      EPropertyMemberTypes.Owner,
    ],
    allowedPayeeRole: [EPropertyMemberTypes.Broker, EPropertyMemberTypes.Owner],
    icon: "houseNotes",
  },
  {
    ids: [EPaymentOrderType.BrokerFee],
    repetitionType: EPaymentRepetitionType.Once,
    repetitionDay: 1,
    allowedPayerRoles: [EPropertyMemberTypes.Owner],
    defaultPayerRole: EPropertyMemberTypes.Owner,
    defaultPayeeRole: EPropertyMemberTypes.Broker,
    allowedPayeeRole: [EPropertyMemberTypes.Broker],
    icon: "broker",
  },
  {
    ids: [EPaymentOrderType.OtherOneoff],
    repetitionType: EPaymentRepetitionType.Once,
    repetitionDay: 1,
    allowedPayerRoles: [
      EPropertyMemberTypes.Tenant,
      EPropertyMemberTypes.Parent,
      EPropertyMemberTypes.Owner,
    ],
    allowedPayeeRole: [EPropertyMemberTypes.Broker, EPropertyMemberTypes.Owner],
    icon: "billStack",
  },
  {
    ids: [
      EPaymentOrderType.IndexationCorrectionRent,
      EPaymentOrderType.IndexationCorrectionCommonCosts,
      EPaymentOrderType.IndexationCorrectionNonCommonCosts,
      EPaymentOrderType.IndexationCorrectionManagementCosts,
      EPaymentOrderType.IndexationCorrectionRentio,
      EPaymentOrderType.IndexationCorrectionOtherRecurring,
    ],
    repetitionType: EPaymentRepetitionType.Once,
    repetitionDay: 1,
    allowedPayerRoles: [],
    allowedPayeeRole: [],
    icon: "forRentSign",
  },
  {
    ids: [
      EPaymentOrderType.IndexationRetroactiveRent,
      EPaymentOrderType.IndexationRetroactiveCommonCosts,
      EPaymentOrderType.IndexationRetroactiveNonCommonCosts,
      EPaymentOrderType.IndexationRetroactiveManagementCosts,
      EPaymentOrderType.IndexationRetroactiveRentio,
      EPaymentOrderType.IndexationRetroactiveOtherRecurring,
    ],
    repetitionType: EPaymentRepetitionType.Once,
    repetitionDay: 1,
    allowedPayerRoles: [],
    allowedPayeeRole: [],
    icon: "forRentSign",
  },
];
